module.exports = __webpack_public_path__ + "static/media/VectorPoint.0f85b3ab.svg";